import React, { useState, useEffect, useContext } from "react";
import "./addsSlider.scss";
import { useSelector, useDispatch } from "react-redux";
// cookie functions
// for Localization
import { withTranslation, useTranslation } from "react-i18next";
// owl carasoul work start
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
// owl carasoul work end
import { AppBar, Button } from "@material-ui/core";
// material ui
import { Skeleton } from "@material-ui/lab";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import Rating from "@mui/material/Rating";
import { styled } from "@mui/material/styles";
import Adds from "../Adds/Adds";
import StateContext from "../../StateContext";

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  tabsRoot: {
    backgroundColor: 'transparent',
  },
}));

const StyledRating = styled(Rating)({
  "& .MuiRating-iconHover": {
    color: "#ff3d47",
  },
});
const AddsSlider2 = (props) => {
  const { t } = useTranslation();
  const appState = useContext(StateContext);
  const classes = useStyles();

  const {addsInfo} = props;
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if(addsInfo.length > 0){
      setIsLoading(false)
    }
  }, [addsInfo])
  
  // const { appState, appDispatch, isLoading, handleOpensliderCard, value } =
  //   usesliderCard(callingFrom);
  const [tabValue, setTabValue] = useState(0); // You need to initialize tabValue to one of the valid values.

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };
  return (
    <div className="px-3" id="">
      {isLoading ? (
        <>
          <div className="row m-0 mb-4 mt-3 d-flex flex-row">
            <div className="col-6  ">
              <Skeleton height={50} />
            </div>
            <div className="col-10 ">
              <Skeleton height={50} />
            </div>
            <div className="col-3 ">
              <Skeleton height={50} />
            </div>
          </div>
        </>
      ) : (
        addsInfo != null && (
          <>
            <div
            id="wrapperAddSliders"
              className={`row sliderTabsParent  pb-4 pt-3`}
            >
              <AppBar className="appBar featuredAppBar" position="static">
                <Tabs
                  value={tabValue}
                  onChange={handleChange}
                  aria-label="icon label tabs example"
                  variant="scrollable"
                  scrollButtons="auto"
                  
                  allowScrollButtonsMobile
                  classes={{
                    root: classes.tabsRoot,
                  }}
                >
                  {addsInfo.length > 0 && addsInfo.map((data, ind) => {
                    ind += 1;
                    return (
                     (
                        <Tab
                       
                          key={ind}
                          style={{
                            border: `1px solid #0000 `,
                            background: `#0000`,
                            boxSizing: "border-box",
                          }}
                          icon={
                            // {addsInfo != null && <Adds data={addsInfo}/>
                            <div className="w-100 item black " key={ind}>
                            <a className="w-100 cursor-pointer text-decoration-none">
                              <div
                                style={{
                                  background: `linear-gradient(90deg, rgba(0, 0, 0, 0.67) 0%, rgba(0, 0, 0, 0.19) 100%), 
                                            url(${
                                              data?.content != null
                                                ? `${data?.content}`
                                                : `./Rectangle_16965.png`
                                            }) center center / cover no-repeat`,
                                }} >
                                {/* <div className="cardImageInner d-flex  align-items-center justify-content-between ">
                                  <div className="largeAvatar pt-3">
                                   
                                  </div>
                                  {(rewards?.punch?.total != undefined &&
                                  active) ? (
                                    <div className="punchRatingMain  ">
                                      {(redeemable && !punchable )? <h6 className="readyToCalime">Ready to Claim</h6> :  <StyledRating
                                        name="customized-color"
                                        defaultValue={handleLoyalPunch(
                                          rewards?.punch?.collected,
                                          rewards?.punch?.total,
                                          5
                                        )}
                                        max={handleMaxPunch(
                                          rewards?.punch?.total
                                        )}
                                        getLabelText={(value) =>
                                          `${value} Heart${
                                            value !== 1 ? "s" : ""
                                          }`
                                        }
                                        precision={0.5}
                                        icon={
                                          <img
                                            src={`/images/loyalCardIconFilled.svg`}
                                          />
                                        }
                                        emptyIcon={
                                          <img
                                            style={{ opacity: 0.55 }}
                                            src={`/images/loyalCardIconUnFilled.svg`}
                                          />
                                        }
                                        disabled
                                      />}
                                     
                                    </div>
                                  ) : (
                                    <p className="pt-3 cardPrice familyPoppins">
                                      {" "}
                                      No Punchs{" "}
                                    </p>
                                  )}
                                </div> */}

                                <div className=" cardContent py-3 d-flex align-items-center justify-content-between">
                                  <h1 className="cardProductName align-self-start   text-uppercase familyPoppins600 ">
                                    {/* {get_lang(
                                      sliderName,
                                      appState.langValue
                                    )} */}
                                    {data?.name}
                                  </h1>
                                  {/* rewards?.punch?.collected,
                                          rewards?.punch?.total, */}
{/* 
                                  <h4
                                    className={` text-right align-self-end  text-lowercase cardPrice familyPoppins ${
                                      appState.langValue == "ar" ? "" : ""
                                    }`}
                                  >
                                    {` ${rewards?.punch?.collected ?? 0 } of ${rewards?.punch?.total} Punches`}
                                  </h4> */}

                                  {/* {get_lang(
                                    description,
                                    appState.langValue
                                  ) != null ? (
                                    <h4
                                      className={` text-right align-self-end  text-lowercase cardPrice familyPoppins ${
                                        appState.langValue == "ar" ? "" : ""
                                      }`}
                                    >
                                      {get_lang(
                                        description,
                                        appState.langValue
                                      ).substring(0, 30)}...
                                    </h4>
                                  ) : (
                                    <h4  className="py-2"></h4 >
                                  )} */}
                                </div>
                              </div>
                            </a>
                          </div>
                            // <Adds data = {data}/> 
                          }
                          
                        />
                      )
                    );
                  })}
                </Tabs>
              </AppBar>
            </div>
          </>
        )
      )}
    </div>
  );
};

export default withTranslation()(AddsSlider2);
